class FeaturedDetailedProduct extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.swatches = Array.from(this.querySelectorAll('.fdp-swatch'));
    this.prices = this.querySelectorAll('.product__price[data-color]');
    this.variantSelect = this.querySelector('.product-variant-select');
    this.variantInput = this.querySelector('input[data-variant-id]');
    this.atcButton = this.querySelector('.add-to-cart-button');
    this.currentColorLabel = this.querySelector('.fdp-current-color');

    this.mainWrapper = this.querySelector('.product__media-slider .swiper-wrapper');
    this.thumbsWrapper = this.querySelector('.product__media-thumbs .swiper-wrapper');

    this.productMediaEl = this.querySelector('product-media');

    this.allMainSlides = Array.from(this.mainWrapper.children).map(slide =>
      slide.cloneNode(true)
    );

    this.allThumbSlides = Array.from(this.thumbsWrapper.children).map(slide =>
      slide.cloneNode(true)
    );
    

    if (this.swiperEl && this.swiperEl.swiper) {
      this.swiper = this.swiperEl.swiper;
    }

    if (this.swiperThumb && this.swiperThumb.swiper) {
      this.swiperThumb = this.swiperThumb.swiper;
    }

    this.bindEvents();

    const activeSwatch = this.querySelector('.fdp-swatch.fdp-swatch-active');
    if (activeSwatch) {
      this.changeActiveSwatch(activeSwatch);
    }
  }

  bindEvents() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        this.changeActiveSwatch(swatch);
      });
    });
  }

  changeActiveSwatch(swatch) {
    const color = swatch.dataset.color;

    this.swatches.forEach(s => {
      s.classList.remove('fdp-swatch-active');
      s.setAttribute('aria-checked', 'false');
    });

    swatch.classList.add('fdp-swatch-active');
    swatch.setAttribute('aria-checked', 'true');

    if(!this.hasAttribute('wo-rebiuld-swiper-color')){
      this.rebuildSwiperByColor(color);
    }
    
    this.filterPrices(color);
    this.updateVariantsFromSwatch(swatch);
    this.refreshCurrentColorLabel(color);
  }

  refreshCurrentColorLabel(color) {
    if (this.currentColorLabel) {
      this.currentColorLabel.textContent = "Color: " +  color.replace("Swatch-", "").replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  }

  filterPrices(color) {
    this.prices.forEach(price => {
      price.classList.remove('active');

      if (price.dataset.color === color) {
        price.classList.add('active');
      }
    });
  }

  updateVariantsFromSwatch(swatch) {
    const dataScript = swatch.querySelector('.fdp-swatch-data');
    if (!dataScript) return;

    let data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Invalid JSON in fdp-swatch-data', e);
      return;
    }
    document.dispatchEvent(
  new CustomEvent('videowise:toggle', {
    detail: {
      handle: data.handle
    }
  })
);
    if (!this.variantSelect || !this.variantInput || !this.atcButton) return;

    this.variantSelect.innerHTML = `<option value="">Select a Size</option>`;

    data.variants.forEach(variant => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;

      if (!variant.available) {
        option.setAttribute('data-available', 'false');
        option.setAttribute('disabled', 'disabled');
      } else {
        option.setAttribute('data-available', 'true');
      }

      this.variantSelect.appendChild(option);
    });

    this.variantInput.value = '';
    this.atcButton.disabled = true;
    this.atcButton.textContent = 'Add to Cart';
  }

  rebuildSwiperByColor(color) {
    if (!this.mainWrapper || !this.thumbsWrapper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.swiperThumb) {
      this.swiperThumb.destroy(true, true);
      this.swiperThumb = null;
    }

    const mainSlides = this.allMainSlides.filter(slide =>
      slide.dataset.color === color
    );

    const thumbSlides = this.allThumbSlides.filter(slide =>
      slide.dataset.color === color
    );

    this.mainWrapper.innerHTML = '';
    this.thumbsWrapper.innerHTML = '';

    mainSlides.forEach(slide => {
      this.mainWrapper.appendChild(slide.cloneNode(true));
    });

    thumbSlides.forEach(slide => {
      this.thumbsWrapper.appendChild(slide.cloneNode(true));
    });

    setTimeout(() => {
      this.productMediaEl.destroySwiper();
      this.productMediaEl.initSliders();
    }, 0);
  }

}

customElements.define('featured-detailed-product', FeaturedDetailedProduct);
